const eInvoiceConsentOptions = [
  {
    "value": true,
    "label": "contractor.table.eInvoiceConsent.granted"
  },
  {
    "value": false,
    "label": "contractor.table.eInvoiceConsent.notGranted"
  }
]
export default eInvoiceConsentOptions
